import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { card, err } from "./HubShell";
import { Mail } from "lucide-react";

const OPTS = [["weekly", "Weekly", "Every Monday"], ["monthly", "Monthly", "First Monday of the month"], ["paused", "Paused", "No digest emails"]];

export const CreatorDigestPrefs = () => {
  const [v, setV] = useState(null);
  useEffect(() => { api.get("/tvnet/creator/digest-prefs").then((r) => setV(r.data.digest)).catch(() => {}); }, []);
  const set = async (d) => { const prev = v; setV(d); try { await api.post("/tvnet/creator/digest-prefs", { digest: d }); toast.success(d === "paused" ? "Digest emails paused" : `Digest set to ${d}`); } catch (e) { setV(prev); toast.error(err(e)); } };
  if (!v) return null;
  return (
    <section className={`${card} p-5 flex flex-wrap items-center gap-4`} data-testid="digest-prefs">
      <div className="flex items-center gap-2"><Mail className="w-4 h-4 text-indigo-300" /><span className="font-semibold text-sm">Creator digest email</span></div>
      <div className="flex gap-1 rounded-lg bg-[#0d1424] p-1" role="radiogroup">{OPTS.map(([k, l, hint]) => <button key={k} role="radio" aria-checked={v === k} onClick={() => set(k)} title={hint} className={`px-3 py-1.5 rounded-md text-xs font-semibold transition-colors ${v === k ? "bg-indigo-600 text-white" : "text-slate-400 hover:text-white"}`} data-testid={`digest-pref-${k}`}>{l}</button>)}</div>
      <span className="text-xs text-slate-500" data-testid="digest-pref-hint">{OPTS.find((o) => o[0] === v)?.[2]}</span>
    </section>
  );
};
